import React from 'react';

import { FormSubmitButton } from '../../components/Button/PrimaryButton';
import CustomDatePicker from '../../components/FormCom/CustomDatePicker';
import { FormComponent } from '../../components/FormCom/FormComponent';
import {
  DeliverDateDataType,
  deliverDateInitialValues,
  DeliverDateSchema,
} from '../../model/deliverDate.model';

interface IDeliveryDateForm {
  setIsDisabled: (...args: any[]) => void;
}

const DeliveryDateForm: React.FC<IDeliveryDateForm> = ({ setIsDisabled }) => {
  const onSubmit = async (values: DeliverDateDataType) => {
    setIsDisabled(false);
    alert(JSON.stringify(values));
  };

  return (
    <FormComponent
      initialValues={deliverDateInitialValues}
      schema={DeliverDateSchema}
      onSubmit={onSubmit}
      className="datePicker"
    >
      <CustomDatePicker
        name="deliveryDate"
        placeholder="Choose Delivery Date"
        minDate={new Date()}
        dateFormat="dd-MM-yyyy"
      />

      <FormSubmitButton type="submit">Set Date</FormSubmitButton>
    </FormComponent>
  );
};

export default DeliveryDateForm;
